
import AdminNewComponent from "../../../components/admins/New.vue";

export default {
  components: {
    AdminNewComponent,
  },
};
